import { IBusinessCatalogueData } from '@/stores/catalogues/types';

export const approveRequiredFields: (keyof IBusinessCatalogueData)[] = ['name', 'pages'];
